import styled, { css } from 'styled-components';
import { subsetTokens } from '../../tokens/components/Subset/tokens';

export const SubsetWrapper = styled.div`
  margin-top: 16px;

  ${({ theme }) => css`
    padding-left: calc(${theme.indent} * ${subsetTokens.CoreIndentation});
  `}
`;
